import { AdapterDateFns as AdapterDateFnsV3 } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { Grid } from '@mui/material'

const DateInput = ({ title, id, format, value, setDay }) => {
  const handleChange = (date) => setDay(date)
  return (
    <Grid size={{ xs: 12, sm: 6, md: 6, lg: 3 }} className="transaction-item">
      <label htmlFor={id}>{title}</label>
      <br />
      <LocalizationProvider dateAdapter={AdapterDateFnsV3}>
        <DatePicker
          id={id}
          className="transaction-date-field"
          disableFuture
          format={format}
          value={value.setHours(0, 0, 0, 0)}
          onChange={handleChange}
        />
      </LocalizationProvider>
    </Grid>
  )
}

export default DateInput
